<template>
    <div>
      <div v-if="isLoading" class="tw-bg-white tw-min-h-screen">
        <Loader />
      </div>
      <div v-else>
        <div v-if="is_default">
          <customReport />
        </div>
        <div v-else>
          <PlugNPlay />
        </div>
      </div>
    </div>
  </template>
  <script>
  import customReport from "./CustomReport.vue";
  import PlugNPlay from "../PlugNPlay/PlugNPlay.vue";
  import Loader from "../../Components/Loader.vue";
  
  export default {
    name: "CustomReportWrapper",
    components: { customReport, PlugNPlay, Loader },
    data: function () {
      return {
        is_default: true,
        isLoading: false,
      };
    },
    mounted() {
      this.getConnectedAccount();
    },
    methods: {
      getConnectedAccount() {
        this.isLoading = true;
        const url = "/api/slate/platformstatus";
        this.$http
          .get(url)
          .then((res) => {
            this.isLoading = false;
            this.is_default = res.data.data.account_connected;
          })
          .catch((err) => {
            console.error(err);
            this.isLoading = false;
          });
      },
    },
  };
  </script>
  